export const MODE_PARAM = "mode"
export const TEAM_PARAM = "team"
